<template>
    <li>
        <!-- SHARE MENU LINK -->
        <a href="" id="share-cart-vue" @click.prevent="openShareModal($event)">
            <i class="csi-iconfont csi-share"></i>
            {{labels[1025]}}<!-- label: Share Cart (title) -->
        </a>

        <!-- MODAL WINDOW -->
        <modal v-if="showShareModal" id="cartSharingVue" @close="closeShareModal" wrap-form="true" @submit-form="submitShareCart">
            <template v-slot:header>
                <span class="ui-dialog-title">{{labels[1025]}}</span><!-- Label: Share Cart -->
            </template>

            <template v-slot:body>
                <div v-if="!shareSubmitted" id="share-cart-vue">
                    <form ref="shrCartForm" name="shrCart" id="shrCartVue" @submit.prevent="submitShareCart()" class="std">
                        <p><em>{{labels[1165]}}<!-- Label: Send a copy of your shopping cart to someone. --></em></p>
                        <div>
                            <label>{{labels[1166]}}<!-- Label: To Email Address -->:</label>
                            <input type="email" class="form-control input-md" v-model="shareEmail" placeholder="email address" name="toemail" id="toemail" required />
                            <!--TRUSTING BROWSER VALIDATION --> <!--<label class="errorMsg">{{labels[1167]}}</label>--><!-- label:  Enter a valid email address. -->
                        </div>
                        <div>
                            <label>{{labels[1168]}}<!-- Message -->:</label><!-- label: -->
                            <textarea name="comments" id="comments" v-model="shareComments" rows="5" class="form-control input-md">
                                <!-- Label: Take a look at this shopping cart from the Campbell Scientific website. -->
                            </textarea>
                        </div>
                        <!-- needed to place this here so it was inside the form, usually itd be in the footer slot -->
                        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                            <div class="ui-dialog-buttonset">
                                <button type="button" @click="closeShareModal(false)" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                                    <span class="ui-button-text">{{labels[1030]}}</span><!-- label: Cancel -->
                                </button>
                                <button type="submit" class="btn-primary ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                                    <span class="ui-button-text">{{labels[1029]}}</span><!-- label: Send -->
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <div v-else>
                    {{shareMsg}}
                </div>
            </template>

            <template v-slot:footer>
                <div v-if="shareSubmitted" class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                    <div class="ui-dialog-buttonset">
                        <button type="button" @click="closeShareModal(false)" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                            <span class="ui-button-text">{{labels[1034]}}</span><!-- label: Close -->
                        </button>
                    </div>
                </div>
                <span v-else></span>
            </template>
        </modal>
    </li>
</template>

<script>
import { ref } from '@vue/composition-api'
import axios from "axios"
import useAlerts from '../../shared/composables/useAlerts'
import useCMS from "../../shared/composables/useCMS"
import Modal from '../../shared/components/Modal.vue'

export default {
    name: 'CartShare',
    components: {
        Modal
    },
    setup () {
        const { labels } = useCMS();
        const {shareComments, shareEmail, shareMsg, shareSubmitted, showShareModal, openShareModal, closeShareModal, submitShareCart, showShareSubmitMsg} = useShareCartModal(labels);

        return {
            shareComments,
            shareEmail,
            shareMsg,
            shareSubmitted,
            showShareModal,
            openShareModal,
            closeShareModal,
            submitShareCart,
            showShareSubmitMsg,
            labels
        }
    }
}

function useShareCartModal(labels) {
    const { addAlert } = useAlerts();

    const shareComments = ref(labels[1169]);
    const shareEmail = ref(null);
    const shareMsg = ref(null);
    const shareSubmitted = ref(false);
    const showShareModal = ref(false);

    function openShareModal () {
        showShareModal.value = true;
        shareSubmitted.value = false;
    }

    function closeShareModal () {
        showShareModal.value = false;
    }

    function submitShareCart () {
        var params = new URLSearchParams({
            toemail: shareEmail.value,
            comments: shareComments.value
        });

        axios.post('/actions/cart.cfc?method=shareCart', params).then(
            (response) => {
                if (response.status === 200){
                    showShareSubmitMsg(response.data.msg);
                    clearShareForm();
                }
            }
        ).catch((error) => {
            addAlert('An error occurred sharing your cart.', 'alert-danger', 7000);
            console.log(error);
        });
    }

    function showShareSubmitMsg (msg) {
        shareSubmitted.value = true;
        shareMsg.value = msg;
        setTimeout(function () {
            shareSubmitted.value = false;
            closeShareModal();
        }, 8000);
    }

    function clearShareForm () {
        shareComments.value = '';
        shareEmail.value = '';
    }

    return {
        shareComments,
        shareEmail,
        shareMsg,
        shareSubmitted,
        showShareModal,
        openShareModal,
        closeShareModal,
        submitShareCart,
        showShareSubmitMsg
    }
}

</script>
